import React from 'react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { Instagram, Send } from 'lucide-react';

export const ContactSection = () => {
  return (
    <section id="contact" className="py-20 px-4">
      <div className="container mx-auto">
        <div className="max-w-4xl mx-auto">
          <Card className="glass-card border-primary/30 overflow-hidden relative">
            {/* Decorative Background Elements */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-primary/10 rounded-full blur-3xl" />
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-accent/10 rounded-full blur-3xl" />
            
            <CardContent className="p-8 md:p-12 relative z-10">
              <div className="text-center space-y-6">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/20 mb-4">
                  <Instagram className="w-8 h-8 text-primary" />
                </div>
                
                <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-foreground">
                  Ready to Get <span className="gradient-text">Started</span>?
                </h2>
                
                <p className="text-lg text-muted-foreground max-w-2xl mx-auto leading-relaxed">
                  Message us on Instagram to purchase any offer. We'll guide you through the entire process 
                  and you only pay after activation is confirmed.
                </p>

                {/* Instagram CTA */}
                <div className="pt-4">
                  <Button
                    size="lg"
                    className="bg-primary hover:bg-primary-glow text-primary-foreground shadow-elegant text-lg px-10 py-7 font-bold hover-glow"
                    onClick={() => window.open('https://www.instagram.com/metalearners.shop', '_blank')}
                  >
                    <Instagram className="w-6 h-6 mr-3" />
                    Message us on Instagram
                  </Button>
                </div>

                {/* Instagram Handle */}
                <div className="pt-4">
                  <p className="text-sm text-muted-foreground">Our Instagram handle:</p>
                  <a 
                    href="https://www.instagram.com/metalearners.shop"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary hover:text-primary-glow font-semibold text-lg transition-colors inline-flex items-center gap-2 mt-1"
                  >
                    @meta_learners
                    <Send className="w-4 h-4" />
                  </a>
                </div>

                {/* Trust Indicators */}
                <div className="pt-8 grid sm:grid-cols-3 gap-6">
                  <div className="space-y-1">
                    <p className="text-2xl font-bold text-foreground">5-30min</p>
                    <p className="text-xs text-muted-foreground">Average activation time</p>
                  </div>
                  <div className="space-y-1">
                    <p className="text-2xl font-bold text-foreground">24/7</p>
                    <p className="text-xs text-muted-foreground">Customer support</p>
                  </div>
                  <div className="space-y-1">
                    <p className="text-2xl font-bold text-foreground">100%</p>
                    <p className="text-xs text-muted-foreground">Pay after activation</p>
                  </div>
                </div>

                {/* Optional Contact Methods */}
                <div className="pt-6 border-t border-border/50">
                  <p className="text-xs text-muted-foreground">
                    Instagram is our primary contact method. Other contact options available in DM.
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};
